/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/

/* import Logger from "../lib/logger"; */

export default function () {
  const NAME = 'Global';
  /* Logger.info(`${NAME} > loading`); */

  // Vars
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
  const main = document.querySelector('main');
  const drawers = document.querySelector('.site-header__drawers');
  const headerWrapper = document.querySelector('#HeaderWrapper');
  const searchbar = headerWrapper.querySelector('[data-type="search"]');
  let scrollY = 0;

  // Logic
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
  const onOpen = () => {
    scrollY = window.scrollY;
    main.style.transform = `translateY(-${window.scrollY}px)`;
    setTimeout(() => {
      if (scrollY > 0 && !headerWrapper.classList.contains('header-wrapper--compressed')) {
        searchbar.style.display = 'none';
      }
    }, 0);
  }

  const onClose = () => {
    main.style.transform = null;
    searchbar.style.display = null;
    setTimeout(() => {
      window.scrollTo(0,scrollY);
    }, 0);
  }
  /**
   * init --- Initialization block
   */
  function init() {
    /* Logger.info(`${NAME} > init`); */
    
    document.addEventListener('mobileNav:open', onOpen);
    document.addEventListener('mobileNav:close', onClose);
    drawers.addEventListener('pointerup', (e) => {
      if (e.target === drawers) onClose();
    });
  }

  // Do not edit below this line...
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
  /* Logger.info(`${NAME} > loaded`); */

  init();
}
